/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/no-unescaped-entities */

import React, { useState, useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';

const imageList = [
  'img1.jpg', 'img2.jpg', 'img3.jpg', 'img4.jpg', 'img5.jpg', 'img6.jpg',
  'img7.jpg', 'img8.jpg', 'img9.jpg', 'img10.jpg', 'img11.jpg', 'img12.jpg',
  'img13.jpg', 'img14.jpg', 'img15.jpg', 'img16.jpg', 'img17.jpg', 'img18.jpg',
  'img19.jpg', 'img20.jpg', 'img21.jpg', 'img22.jpg', 'img23.jpg', 'img24.jpg',
  'img25.jpg', 'img26.jpg', 'img27.jpg', 'img28.jpg', 'img29.jpg', 'img30.jpg',
  'img31.jpg', 'img32.jpg', 'img33.jpg',
];

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (img) => setSelectedImage(img);
  const closeModal = () => setSelectedImage(null);

  const handleKeyDown = (e, img) => {
    if (e.key === 'Enter' || e.key === ' ') {
      openModal(img);
    }
  };

  const handleModalKey = (e) => {
    if (!selectedImage) return;

    const currentIndex = imageList.indexOf(selectedImage);

    if (e.key === 'Escape') {
      closeModal();
    } else if (e.key === 'ArrowRight') {
      const nextIndex = (currentIndex + 1) % imageList.length;
      setSelectedImage(imageList[nextIndex]);
    } else if (e.key === 'ArrowLeft') {
      const prevIndex = (currentIndex - 1 + imageList.length) % imageList.length;
      setSelectedImage(imageList[prevIndex]);
    }
  };

  useEffect(() => {
    if (selectedImage) {
      window.addEventListener('keydown', handleModalKey);
    } else {
      window.removeEventListener('keydown', handleModalKey);
    }

    return () => window.removeEventListener('keydown', handleModalKey);
  }, [selectedImage]);

  return (
    <section className="w-full min-h-screen flex items-center justify-center bg-white px-4 sm:px-6 lg:px-12 py-10 sm:py-16">
      <div className="w-full max-w-6xl text-gray-700 space-y-6">
        <Fade direction="up" triggerOnce>
          <h1 className="text-4xl sm:text-5xl font-bold text-theme-blue mb-6 sm:mb-10">
            Our Work Gallery
          </h1>
        </Fade>

        <Fade direction="up" delay={200} triggerOnce>
          <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
            {imageList.map((filename) => (
              <div
                key={filename}
                role="button"
                tabIndex={0}
                onClick={() => openModal(filename)}
                onKeyDown={(e) => handleKeyDown(e, filename)}
                className="overflow-hidden rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer"
              >
                <img
                  src={`assets/images/gallery/${filename}`}
                  alt={filename}
                  className="object-cover w-full h-64 hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </Fade>

        {selectedImage && (
          <div
            role="button"
            aria-label="Close image modal"
            tabIndex={0}
            onClick={closeModal}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') closeModal();
            }}
            className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
          >
            <div
              role="button"
              tabIndex={0}
              aria-label="Modal content area"
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
              }}
              className="relative max-w-4xl w-full px-4"
            >
              <button
                type="button"
                onClick={closeModal}
                className="absolute top-2 right-2 text-white text-3xl font-bold hover:text-red-400"
                aria-label="Close image modal"
              >
                &times;
              </button>
              <img
                src={`assets/images/gallery/${selectedImage}`}
                alt="Enlarged"
                className="w-full max-h-[90vh] object-contain rounded-xl"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
